enum Country {
  FRANCE = "France",
  AUSTRIA = "Austria",
  ENGLAND = "England",
  GERMANY = "Germany",
  RUSSIA = "Russia",
  ITALY = "Italy",
  TURKEY = "Turkey",
}

export const abbrMap = {
  Russia: "RUS",
  Germany: "GER",
  Italy: "ITA",
  Austria: "AUS",
  England: "ENG",
  France: "FRA",
  Turkey: "TUR",
};

export default Country;
